import { t } from '../i18n'
import { siteUrl } from '../platform'
import { openExternal } from '../telegram'

/** Ссылки на условия и политику. На экране входа — с фразой согласия
 *  (требование App Store для приложений с перепиской), в профиле — просто ссылки. */
export default function Legal({ agree = false }: { agree?: boolean }) {
  const link = (path: string, label: string) => (
    <button className="link inline" onClick={() => openExternal(siteUrl(path))}>
      {label}
    </button>
  )
  if (agree) {
    return (
      <p className="muted small legal">
        {t().legalAgree} {link('/terms', t().legalTerms)} {t().legalAnd} {link('/privacy', t().legalPrivacy)}.
      </p>
    )
  }
  return (
    <p className="muted small legal">
      {link('/terms', t().legalTerms)} · {link('/privacy', t().legalPrivacy)} · {link('/support', t().legalSupport)}
    </p>
  )
}
